/**
 * Shared color utility functions
 * Consolidated from brazil-map.js and brazil-choropleth-map.js
 */

/**
 * Convert hex color to RGB object
 * @param {string} hex - Hex color string (e.g. '#1877F2')
 * @returns {{ r: number, g: number, b: number }} RGB values
 */
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : { r: 24, g: 119, b: 242 };
};

/**
 * Interpolate between two hex colors
 * @param {string} color1 - Start hex color
 * @param {string} color2 - End hex color
 * @param {number} factor - Interpolation factor (0-1)
 * @returns {{ r: number, g: number, b: number }} Interpolated RGB
 */
export const interpolateRgb = (color1, color2, factor) => {
  const c1 = hexToRgb(color1);
  const c2 = hexToRgb(color2);
  return {
    r: Math.round(c1.r + (c2.r - c1.r) * factor),
    g: Math.round(c1.g + (c2.g - c1.g) * factor),
    b: Math.round(c1.b + (c2.b - c1.b) * factor)
  };
};
